(function($){

    //Helpers
    function parseDLClass(el){
        const cls = Array.from(el.classList)
            .find(c => c.startsWith('datalayer-'));
        if (!cls) return null;

        const parts = cls.slice('datalayer-'.length).split('-');
        const sanitize = v => (!v || v === 'null') ? null : v;
        return {
            event: sanitize(parts[0]),
            location: sanitize(parts[1]),
            service: sanitize(parts[2])
        };
    }

    function pushFromClass(el){
        const info = parseDLClass(el);
        if (!info || !info.event) return;

        window.datalayer = window.datalayer || [];

        window.datalayer_push({
            event: info.event,
            location:  info.location,
            service: info.service
        });
    }

    $(function(){
        $(document).on('click', '[class*="datalayer-"]', function(){
            pushFromClass(this);
        });
    });
})(jQuery)